import { GET, omsBaseUrlApi } from '@constants/generic-constants.js';
import NetworkManager from '../../services/network-service.js';
import PermissionsHelper from '../../auth/helper/PermissionHelper.js';
import {
  ACTION_ACCOUNT_STATEMENT,
  ACTION_INDEX,
  ACTION_SHOW,
  PERMISSION_KEY_SETTLEMENT,
} from '../../constants/permission-constants.js';
import { ACCESS_DENIED } from '../../constants/seller-center-paths.js';
import { redirectToPath } from '../../utils/utils.js';

export const settlementsListingApi = (params = '') => {
  return new Promise((resolve, reject) => {
    if (!PermissionsHelper.getPermissions(PERMISSION_KEY_SETTLEMENT, ACTION_INDEX)) {
      redirectToPath(ACCESS_DENIED);
      return;
    }
    let url = `${omsBaseUrlApi}/settlements${params}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const settlementDetailApi = (id) => {
  return new Promise((resolve, reject) => {
    if (!PermissionsHelper.getPermissions(PERMISSION_KEY_SETTLEMENT, ACTION_SHOW)) {
      redirectToPath(ACCESS_DENIED);
      return;
    }
    let url = `${omsBaseUrlApi}/settlements/${id}`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const accountStatementDocumentApi = (id) => {
  return new Promise((resolve, reject) => {
    if (!PermissionsHelper.getPermissions(PERMISSION_KEY_SETTLEMENT, ACTION_ACCOUNT_STATEMENT)) {
      redirectToPath(ACCESS_DENIED);
      return;
    }
    let url = `${omsBaseUrlApi}/settlements/${id}/account_statement`;
    NetworkManager.performRequest(url, null, GET)
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
